/** Client mirror of the backend compute_invoice_totals (ROUND_HALF_UP, 2dp). */

const roundHalfUp = (value: number): number => {
  // Number-safe half-up at 2dp: shift, add epsilon to survive float artifacts
  // like 7.253625*100=725.3624999, round, shift back.
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export interface InvoiceTotals {
  subtotal: number
  taxAmount: number
  retainageAmount: number
  amount: number
}

export const computeInvoiceTotals = (
  lineAmounts: Array<number | string | null | undefined>,
  taxPct?: number | string | null,
  retainagePct?: number | string | null
): InvoiceTotals => {
  const subtotal = lineAmounts.reduce<number>(
    (sum, value) => sum + (Number(value) || 0),
    0
  )
  const tax = roundHalfUp((subtotal * (Number(taxPct) || 0)) / 100)
  const retainage = roundHalfUp((subtotal * (Number(retainagePct) || 0)) / 100)
  return {
    subtotal: roundHalfUp(subtotal),
    taxAmount: tax,
    retainageAmount: retainage,
    amount: roundHalfUp(subtotal + tax - retainage)
  }
}
